import { http } from "@/lib/http";
import { useToast } from "@/providers/toast.provider";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/** "Reabrir vendas" (`open: true`) / "Fechar vendas" (`open: false`) do ADMIN. */
export function useSetSaleOrders() {
  const queryClient = useQueryClient();
  const { toaster } = useToast();

  return useMutation({
    mutationFn: async ({ id, open }: { id: string; open: boolean }) => {
      await http.post(`/sales/${id}/${open ? "open-orders" : "close-orders"}`);
    },

    onSuccess: (_, { open }) => {
      queryClient.invalidateQueries({ queryKey: ["sale", "me"] });
      toaster(open ? "Vendas reabertas" : "Vendas fechadas", "success");
    },

    onError: (error) => {
      toaster(error?.message ?? "Algo deu errado!", "error");
    },
  });
}
